import { getQuery } from "../api";

/**
 * Asynchronously fetches application data from a specified URL and manages loading state.
 *
 * @async
 * @function getAppData
 * @returns {Promise<Object>} Resolves to the application data object if successful, or throws an error if the fetch operation fails.
 */
export const getAppData = async () => {
  return await getQuery(`${process.env.REACT_APP_APP_DATA_URL}`);
};

/**
 * Fetches an API key of the specified type from the backend.
 *
 * @async
 * @function getApiKey
 * @param {string} keyType - The type of API key to retrieve (e.g., "googleMaps").
 * @returns {Promise<Object>} Resolves to an object containing the key (e.g., `{ key: "..." }`).
 * @throws {Error} Throws if the network request fails.
 */
export const getApiKey = async (keyType) => {
  return await getQuery(`${process.env.REACT_APP_API_URL}/apikey/${keyType}`);
};
